import React from 'react'

const ExtendedWarrantyDetails = () => {
  return (
    <div>ExtendedWarrantyDetails</div>
  )
}

export default ExtendedWarrantyDetails